import React from 'react';
import { useTranslation } from 'react-i18next';

const InvalidSession = () => {
  const { t } = useTranslation();

  return (
    <div className="denied-container">
      <h1>404</h1>
      <p>{t('session-not-found')}</p>
    </div>
  );
};

export default InvalidSession;
